module.exports = __webpack_public_path__ + "assets/devices/FlatPIR-a08f1f6b60d1f21797bfb4a56013f9a6.svg";